import { Scissors, Leaf, Flower2, Trees, Trash2, Sprout, Beaker, ShieldOff, Shovel, Truck } from "lucide-react";

const SERVICES = [
  { icon: Scissors, title: "Mowing", desc: "Crisp, clean cuts on a schedule that fits your lot.", wide: true },
  { icon: Leaf, title: "Hedging", desc: "Precise hedge shaping for sharp, architectural lines." },
  { icon: Sprout, title: "Mulching", desc: "Fresh mulch to nourish beds & lock in moisture." },
  { icon: Trees, title: "Brush Trimming", desc: "Taming overgrowth with purpose and control." },
  { icon: Flower2, title: "Flower Beds", desc: "Edged, weeded and defined beds that frame the yard." },
  { icon: Trash2, title: "Clean-Ups", desc: "Seasonal, debris and storm clean-ups — spotless." },
  { icon: Beaker, title: "Fertilizer", desc: "Tailored feeding programs for lush, resilient turf." },
  { icon: ShieldOff, title: "Weed Control", desc: "Targeted treatments that keep weeds out for good." },
  { icon: Shovel, title: "Landscaping", desc: "Pavers, stone, beds & xeriscape — call for a custom quote." },
  { icon: Truck, title: "Heavy Debris Removal", desc: "Remodel site prep, trees, brush & trash haul-off — call or email for a quote." },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-32 bg-background">
      <div className="container-ic">
        <div className="max-w-3xl mb-16 md:mb-20">
          <div className="overline mb-4">What We Do</div>
          <h2 className="font-display text-4xl md:text-6xl font-black uppercase tracking-tighter leading-[0.95]">
            Ten services.
            <br />
            <span className="text-primary">One standard.</span>
          </h2>
          <p className="mt-6 text-muted-foreground text-lg max-w-xl">
            Every visit is executed with the same discipline. No shortcuts, no surprises.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-border border border-border">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                className="group bg-background p-8 md:p-10 transition-colors hover:bg-accent"
                data-testid={`service-card-${s.title.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="w-12 h-12 border border-primary/30 flex items-center justify-center group-hover:border-primary group-hover:bg-primary/10 transition-colors">
                    <Icon className="h-5 w-5 text-primary" />
                  </div>
                  <span className="text-xs tracking-widest text-muted-foreground">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="font-display text-2xl md:text-3xl font-bold uppercase tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-muted-foreground leading-relaxed">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
